"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTranscriptionSetting_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserTranscriptionSetting_Factory = /** @class */ (function () {
    function UserTranscriptionSetting_Factory() {
    }
    UserTranscriptionSetting_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            MaxDurationMs: model.MaxDurationMs,
            Mode: model.Mode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SilenceTimeoutMs: model.SilenceTimeoutMs,
            UserId: model.UserId,
        };
        return result;
    };
    UserTranscriptionSetting_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            MaxDurationMs: model.MaxDurationMs,
            Mode: model.Mode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SilenceTimeoutMs: model.SilenceTimeoutMs,
            UserId: model.UserId,
        };
        return result;
    };
    return UserTranscriptionSetting_Factory;
}());
exports.UserTranscriptionSetting_Factory = UserTranscriptionSetting_Factory;
